<template>
  <div class='animated fadeIn'>
    <h4 data-v-8a07588c="" class="card-header" style="position: fixed;z-index: 999;width: 100%;top: 50px;">All <b>Notifications</b></h4>
    <div class="" style="margin-top: 40px;">
      <div class="list-group list-group-accent">
        <div v-for="notification in notificationList" :key="notification.uuid"
          @click="readNotification(notification.uuid, notification)" :class="'list-group-item list-group-item-accent-warning list-group-item-divider notification-item' + (!notification.unread ? ' hasRead' : '')">
          <div>{{notification.title}}</div>
          <small class="text-muted mr-3"><i class="icon-clock"></i>&nbsp; {{notification.createdAt}}</small>
        </div>
        <div v-if="!lastPage && notificationList.length" @click.prevent.self="loadMore" class="list-group-item list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">Load More</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'NotificationsIndex',
  components: {
    DatePicker
  },
  data () {
    return {
      notificationList: [],
      page: 1,
      lastPage: false
    }
  },
  mounted () {
    this.getNotificationList()
  },
  methods: {
    getNotificationList () {
      axios.get(window.AppConfig.apiUrl + 'notification?admin=1&limit=10&page=' + this.page)
        .then(response => {
          if (response === undefined) return false
          if (response.data.page === response.data.page_count) {
            this.lastPage = true
          }
          if (this.page === 1) {
            this.notificationList = []
          }
          for (let i = 0; i < response.data._embedded.notification.length; i++) {
            let url = null
            if (response.data._embedded.notification[i].type === 'Facility') {
              url = '#/facility-booking/' + response.data._embedded.notification[i].facilityBooking
            } else if (response.data._embedded.notification[i].type === 'Complain') {
              url = '#/complaint/' + response.data._embedded.notification[i].complain
            } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'PanicResolve') {
              url = '#/panic-alerts/' + response.data._embedded.notification[i].panicAlert
            } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'Request') {
              url = '#/request/' + response.data._embedded.notification[i]._embedded.request.uuid
            } else if (response.data._embedded.notification[i].type === 'Task') {
              url = '#/tasks/' + response.data._embedded.notification[i]._embedded.task.uuid
              // if (response.data._embedded.notification[i]._embedded.task) {
              //   url = '#/tasks/' + response.data._embedded.notification[i]._embedded.task.uuid
              // } else if (response.data._embedded.notification[i]._embedded.taskNote) {
              //   if (response.data._embedded.notification[i]._embedded.taskNote.request !== null) {
              //     url = '#/request/' + response.data._embedded.notification[i]._embedded.taskNote.request
              //   } else if (response.data._embedded.notification[i]._embedded.taskNote.complain !== null) {
              //     url = '#/complaint/' + response.data._embedded.notification[i]._embedded.taskNote.complain
              //   } else {
              //     url = '#/panic-alerts/' + response.data._embedded.notification[i]._embedded.taskNote.panicAlert
              //   }
              //   // End Task Note
              // } else if (response.data._embedded.notification[i]._embedded.taskPhoto) {
              //   if (response.data._embedded.notification[i]._embedded.taskPhoto.request !== null) {
              //     url = '#/request/' + response.data._embedded.notification[i]._embedded.taskPhoto.request
              //   } else if (response.data._embedded.notification[i]._embedded.taskPhoto.complain !== null) {
              //     url = '#/complaint/' + response.data._embedded.notification[i]._embedded.taskPhoto.complain
              //   } else {
              //     url = '#/panic-alerts/' + response.data._embedded.notification[i]._embedded.taskPhoto.panicAlert
              //   }
              //   // End Task Photo
              // }
            } else {
              url = '#/visitor/' + response.data._embedded.notification[i].visitor
            }
            this.notificationList.push({
              uuid: response.data._embedded.notification[i].uuid,
              userProfile: response.data._embedded.notification[i].userProfile,
              title: response.data._embedded.notification[i].title,
              createdAt: moment(response.data._embedded.notification[i].createdAt).from(moment().format()),
              href: url,
              unread: response.data._embedded.notification[i].unread
            })
          }
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    },
    doFilter () {
      this.page = 1
      if (this.filterBy.DateTime !== null && this.filterBy.DateTime !== '') {
        this.params.start_date = moment(this.filterBy.DateTime[0]).format('YYYY-MM-DD')
        this.params.end_date = moment(this.filterBy.DateTime[1]).format('YYYY-MM-DD')
      } else {
        this.params.start_date = null
        this.params.end_date = null
      }
      this.$router.replace({query: window.setUrlParams(this.params)})
      this.getNotificationList()
    },

    readNotification (uuid, notification) {
      axios.patch(window.AppConfig.apiUrl + 'notification/' + uuid, {unread: 0}).then(response => {
        notification.unread = false
      })
      window.location.href = notification.href
    },
    loadMore () {
      this.page++
      this.getNotificationList()
    }
  }
}
</script>

<style lang="scss" scoped>
    .notification-item {
        cursor: pointer;
        border-bottom: 1px solid #c3c3c3;
        padding: 5px;
        position: relative;
        display: block;
        width: 100%;
        color: #000;
        background-color: #c9ebd5;
        &.hasRead {
          background-color: #fff;
        }
        &:hover {
          color: #000;
          background-color: #fadb4c;
          text-decoration: none;
        }
        .dot {
            color: #f86c6b;
            vertical-align: top;
            padding-right: 5px;
            font-size: 20px;
            /* top: 0; */
            height: 100%;
            margin: 0;
            /* padding: 0; */
            /* float: left; */
            position: absolute;
            top: 1px;
            &.hasRead {
              color: #000;
            }
        }
        .text {
            display: inline-block;
            /* float: left; */
            // padding-left: 26px;
            h4 {
                margin: 0;
                font-size: 100%;
                margin: 0px;
            }
            p {
                font-size: 95%;
                color: #c3c3c3;
                margin: 0px;
            }
        }
        &:nth-last-child(2) {
            border-bottom: 0px solid #c3c3c3;
        }
        &.notification-footer {
            font-size: 100%;
            padding-top: 5px;
            padding-bottom: 5px;
            text-align: center;
            background: #f0f3f5;
            display: block;
            border-bottom: 0px solid #c3c3c3;
        }
    }

    .notif-title {
      position: fixed;z-index: 999;width: 100%
    }
</style>



// WEBPACK FOOTER //
// src/views/notifications/Index.vue